import React from "react";
import { useParams } from "react-router-dom";
import useArticle from "hooks/articles/useArticle";
import ArticleView from "components/articles/ArticleView";
import Loading from "components/common/Loading";

const Article = ({ isEditable }) => {
  const { id } = useParams();
  const { current, isLoading } = useArticle({ id });
  return (
    <div>
      {isLoading ? (
        <Loading />
      ) : (
        <ArticleView article={current} isEditable={isEditable} />
      )}
    </div>
  );
};

export default Article;
